import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { VendaExternaEdit } from '@/features/venda-externa/page/edit/VendaExternaEdit';
import { StringToIdpkSchema } from '@/std/schema';

const RouteVendaExternaParamsSchema = z.discriminatedUnion('action', [
    z.object({
        action: z.literal('cadastrar'),
        idpk: z.undefined().optional(),
    }),
    z.object({
        action: z.enum(['editar', 'clonar', 'visualizar']),
        idpk: StringToIdpkSchema,
    }),
]);

export type RouteVendaExternaParams = z.infer<typeof RouteVendaExternaParamsSchema>;

export const Route = createFileRoute('/a/venda-externa/$action/{-$idpk}')({
    component: Component,
    params: {
        parse: (params) => {
            const result = RouteVendaExternaParamsSchema.safeParse(params);

            return result.success ? result.data : false;
        },
    },
});

function Component() {
    const params = Route.useParams();

    return <VendaExternaEdit {...params} />;
}
